// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICardActivityDto
 */
export interface ICardActivityDto {
    /**
     * 
     * @type {number}
     * @memberof ICardActivityDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICardActivityDto
     */
    claim_status?: string;
    /**
     * 
     * @type {number}
     * @memberof ICardActivityDto
     */
    claim_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof ICardActivityDto
     */
    card_swipe_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof ICardActivityDto
     */
    swiped_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardActivityDto
     */
    approved_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardActivityDto
     */
    authorization_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardActivityDto
     */
    transaction_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICardActivityDto
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardActivityDto
     */
    category_type?: ICardActivityDtoCategoryTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ICardActivityDto
     */
    suppressed?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum ICardActivityDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the ICardActivityDto interface.
 */
export function instanceOfICardActivityDto(value: object): value is ICardActivityDto {
    return true;
}

export function ICardActivityDtoFromJSON(json: any): ICardActivityDto {
    return ICardActivityDtoFromJSONTyped(json, false);
}

export function ICardActivityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardActivityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'claim_status': json['claim_status'] == null ? undefined : json['claim_status'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'card_swipe_date': json['card_swipe_date'] == null ? undefined : (new Date(json['card_swipe_date'])),
        'swiped_amount': json['swiped_amount'] == null ? undefined : json['swiped_amount'],
        'approved_amount': json['approved_amount'] == null ? undefined : json['approved_amount'],
        'authorization_id': json['authorization_id'] == null ? undefined : json['authorization_id'],
        'transaction_id': json['transaction_id'] == null ? undefined : json['transaction_id'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'suppressed': json['suppressed'] == null ? undefined : json['suppressed'],
    };
}

export function ICardActivityDtoToJSON(json: any): ICardActivityDto {
    return ICardActivityDtoToJSONTyped(json, false);
}

export function ICardActivityDtoToJSONTyped(value?: ICardActivityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claim_status': value['claim_status'],
        'claim_id': value['claim_id'],
        'card_swipe_date': value['card_swipe_date'] == null ? undefined : ((value['card_swipe_date']).toISOString()),
        'swiped_amount': value['swiped_amount'],
        'approved_amount': value['approved_amount'],
        'authorization_id': value['authorization_id'],
        'transaction_id': value['transaction_id'],
        'memo': value['memo'],
        'category_type': value['category_type'],
        'suppressed': value['suppressed'],
    };
}

